import { MessageTemplateStatus } from '../models/MessageTemplateStatus';
import { DetailsMessageTemplateSidebarController } from '../detailsMessageTemplateSidebar/DetailsMessageTemplateSidebarController';
import { MessageTemplateDeleted } from '../MessageTemplateController';
import DetailsMessageTemplateSidebarView from '../detailsMessageTemplateSidebar/DetailsMessageTemplateSidebarView.html';
import './messageTemplateItem.scss';
import { MessageTemplateScore } from '../models/MessageTemplateScore';
import { MessageTemplateFeatures } from '../MessageTemplateFeatures';
export class MessageTemplateItemController {
    static $inject = ['$translate', '$rootScope', '$document', 'SidebarContentService'];
    constructor($translate, $rootScope, $document, SidebarContentService) {
        'ngInject';
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$document = $document;
        this.SidebarContentService = SidebarContentService;
        this.elementId = 'message-template';
        this.statusColorMap = {
            [MessageTemplateStatus.Approved]: 'success',
            [MessageTemplateStatus.Pending]: 'info',
            [MessageTemplateStatus.Rejected]: 'rejected',
            [MessageTemplateStatus.InAppeal]: 'in-appeal',
            [MessageTemplateStatus.PendingDeletion]: 'pending-deletion',
            [MessageTemplateStatus.Deleted]: 'deleted',
            [MessageTemplateStatus.Disabled]: 'disabled',
            [MessageTemplateStatus.Paused]: 'paused',
            [MessageTemplateStatus.LimitExceeded]: 'limit-exceeded',
        };
        this.scoreColorMap = {
            [MessageTemplateScore.GREEN]: 'high',
            [MessageTemplateScore.UNKNOWN]: 'pending',
            [MessageTemplateScore.YELLOW]: 'medium',
            [MessageTemplateScore.RED]: 'low',
        };
        this.initialize();
    }
    async initialize() {
        this.messageTemplateScoreEnabled = await MessageTemplateFeatures.isMessageTemplateQualityScoreEnabled();
    }
    $onInit() {
        this.name = this.data.name;
    }
    getTranslationLanguage(language) {
        return this.$translate.instant(`messageTemplateLanguages.${language}`);
    }
    getTranslationStatus(status) {
        return this.$translate.instant(`messageTemplate.status.${status}`);
    }
    getTranslationCategory(category) {
        return this.$translate.instant(`messageTemplate.categories.${category}`);
    }
    getColorByStatus(status) {
        return this.statusColorMap[status];
    }
    getTranslationRecategorized(isRecategorized) {
        return this.$translate.instant(`recategorization.isRecategorized.${isRecategorized ? 'yes' : 'no'}`);
    }
    getTranslationScore(qualityScore) {
        return this.$translate.instant(`score.${qualityScore.score}`);
    }
    getColorByScore(qualityScore) {
        return this.scoreColorMap[qualityScore.score];
    }
    async openDetailsMessageTemplateSidebar(data) {
        await this.SidebarContentService.showSidebar({
            controller: DetailsMessageTemplateSidebarController,
            controllerAs: '$ctrl',
            template: DetailsMessageTemplateSidebarView,
            appendToElement: this.$document[0].getElementById('message-template__main-content-area'),
            allowMultiple: false,
            inputs: {
                $translate: this.$translate,
                elementId: `${this.elementId}-${data.name}`,
                data,
                onDeleteMessageTemplate: this.onDeleteMessageTemplate.bind(this),
                onDuplicateMessageTemplate: this.onDuplicate.bind(this),
            },
        });
    }
    async onDeleteMessageTemplate() {
        this.$rootScope.$emit(MessageTemplateDeleted);
    }
}
MessageTemplateItemController.$inject = ['$translate', '$rootScope', '$document', 'SidebarContentService'];
